import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../icon/icon';
import styles from './close_icon.css';

const CloseIcon = ({ handleClick, visualProps }) => (
    <div
        className={styles[`variant_${visualProps.variant}`]}
        onClick={handleClick}
        onKeyPress={handleClick}
        role="button"
        tabIndex="0"
    >
        <Icon variant="ctm_cross" size="small" color="brand_base_0" />
    </div>
);

CloseIcon.defaultProps = {
    visualProps: {
        variant: 'default'
    }
};

CloseIcon.propTypes = {
    handleClick: PropTypes.func,
    visualProps: PropTypes.object
};

export { CloseIcon };
